// extracted by mini-css-extract-plugin
export default {"commited":"MaterialReal_commited__Josnf"};